import { render, staticRenderFns } from "./ApkInfoSection.vue?vue&type=template&id=57a3274c&scoped=true"
import script from "./ApkInfoSection.vue?vue&type=script&lang=js"
export * from "./ApkInfoSection.vue?vue&type=script&lang=js"
import style0 from "./ApkInfoSection.vue?vue&type=style&index=0&id=57a3274c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a3274c",
  null
  
)

export default component.exports